// this used to define the client side filtering functions
// now it just defines the valid filters coming in from the url

const baseFilters = (function generateBaseFilters() {
  return {
    city: null,
    zoning: null,
    specialtyFeatures: null,
    ceilingHeight: null,
    railServed: null,
    saleLease: null,
    shapefile: null,
    state: null,
    region: null,
    county: null,
    community: null,
    _id: null,
  };
}());

const buildingFilters = (function generateBuildingFilters() {
  return {
    ...baseFilters,
    buildingType: null,
    sqft: null,
    parkingSpaces: null,
    multiTenant: null,
  };
}());

const siteFilters = (function generateSiteFilters() {
  return {
    ...baseFilters,
    acres: null,
    siteCertified: null,
    siteType: null,
  };
}());

export default ({
  buildings: buildingFilters,
  sites: siteFilters,
});



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyFilters.js